import { useSelector } from 'react-redux'
import { selectCardProviders } from 'src/selectors/cardProvider.selector'
import { useMemo } from 'react'
import { haveAnyValue } from 'src/utils/utilitiesV2'

interface ICardChargesProviderHookResponse {
  providers: ISelect[]
  getProvider: (providerId: number) => ISelect
}

const defaultProviderOptions: ISelect[] = [
  { value: null, label: 'Todos' },
  { value: 0, label: 'Sin proveedor' },
]

export const UseCardChargesProviderHook = (): ICardChargesProviderHookResponse => {
  const providers = useSelector(selectCardProviders)

  const providerMapped = useMemo(() => {
    return providers.map(
      (p): ISelect => ({
        value: p.id,
        label: p.name,
      }),
    )
  }, [providers])

  const providerOptions = defaultProviderOptions.concat(providerMapped)

  return {
    providers: providerOptions,
    getProvider: providerId => {
      if (haveAnyValue(providerId)) {
        return providerOptions.find(p => p.value === providerId)
      } else return providerOptions[1]
    },
  }
}
